import { useEffect, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';

import styles from './Home.module.scss';
import { UserResponseModel } from '../../models/users/UserResponseModel';
import { DefaultInfoResponseModel } from '../../models/defaultInfos/DefaultInfoResponseModel';
import { HttpService, IHttpService } from './../../services/httpService';
import {
	INotifierService,
	NotifierService
} from './../../services/notifierService';
import { setUserDetailsAction } from '../../store/user/UserActions';
import { getUserAccount } from '../../AzureADConfig';

const Home = (): JSX.Element => {
	const httpService: IHttpService = useMemo(() => new HttpService(), []);
	const notifierService: INotifierService = useMemo(
		() => new NotifierService(),
		[]
	);

	const [defaultInfoDetails, setDefaultInfoDetails] =
		useState<DefaultInfoResponseModel>({
			id: 0,
			divisionId: 0,
			body: ''
		});

	const dispatch = useDispatch();

	useEffect(() => {
		const userAccount = getUserAccount();

		const dispatchUser = async () => {
			const userDetails = await httpService.get<UserResponseModel>(
				`users/welcome?email=${userAccount.username}`,
				undefined
			);

			if (userDetails.defaultDivisionId) {
				httpService
					.get<DefaultInfoResponseModel>(
						`defaultInfos/${userDetails.defaultDivisionId}`,
						undefined
					)
					.then((defaultInfo) => {
						setDefaultInfoDetails(defaultInfo);
					})
					.catch((err) => notifierService.error());
			}

			dispatch(setUserDetailsAction(userDetails));
		};

		dispatchUser();
	}, [dispatch, httpService, notifierService]);

	return (
		<div className={styles.container}>
			<h1>Welcome</h1>
			<div
				dangerouslySetInnerHTML={{ __html: defaultInfoDetails.body }}
			></div>
		</div>
	);
};

export default Home;
